// Centralized data-testid registry for UnAnonymous
export const HOME = {
};

export const NAV = {
  welcome: "nav-welcome",
  quiz: "nav-quiz",
  journal: "nav-journal",
  mosaic: "nav-mosaic",
  safereach: "nav-safereach",
  dashboard: "nav-dashboard",
  tools: "nav-tools",
  you: "nav-you",
};

export const WELCOME = {
  root: "welcome-page",
  cta: "welcome-start-checkin-btn",
  ctaJournal: "welcome-open-journal-btn",
  ctaSafe: "welcome-safereach-btn",
  ctaMosaic: "welcome-mosaic-btn",
  ctaZen: "welcome-zen-btn",
  ctaProtect: "welcome-protect-btn",
  ctaDrafts: "welcome-drafts-btn",
  ctaLetters: "welcome-letters-btn",
  ctaSettings: "welcome-settings-link",
};

export const QUIZ = {
  root: "quiz-page",
  exit: "quiz-exit-btn",
  questionTitle: "quiz-question-title",
  optionPrefix: "quiz-option-", // append index
  next: "quiz-next-btn",
  back: "quiz-back-btn",
  progress: "quiz-progress",
  startOver: "quiz-start-over-btn",
};

export const RESULTS = {
  root: "results-page",
  category: "results-category",
  saveBtn: "results-save-btn",
  stepForwardBtn: "results-step-forward-btn",
  retakeBtn: "results-retake-btn",
};

export const STEP = {
  root: "step-forward-page",
  exit: "step-forward-exit-btn",
  actionPrefix: "step-forward-action-",
  saveActionPrefix: "step-forward-save-action-",
};

export const SAFE = {
  root: "safereach-page",
  exit: "safereach-exit-btn",
  resourcePrefix: "safereach-resource-",
};

export const JOURNAL = {
  root: "journal-page",
  exit: "journal-exit-btn",
  newEntryBtn: "journal-new-entry-btn",
  textarea: "journal-textarea",
  saveBtn: "journal-save-btn",
  cancelBtn: "journal-cancel-btn",
  promptToggle: "journal-prompt-toggle",
  entryPrefix: "journal-entry-",
  emptyState: "journal-empty-state",
};

export const DASH = {
  root: "dashboard-page",
  tabResults: "dashboard-tab-results",
  tabActions: "dashboard-tab-actions",
  tabEntries: "dashboard-tab-entries",
  clearAllBtn: "dashboard-clear-all-btn",
  itemPrefix: "dashboard-item-",
  deletePrefix: "dashboard-delete-",
  counterPrefix: "dashboard-counter-",
  logMomentBtn: "dashboard-log-moment-btn",
  logMomentOptionPrefix: "dashboard-log-moment-option-",
};

export const MOSAIC = {
  root: "mosaic-page",
  exit: "mosaic-exit-btn",
  addBtn: "mosaic-add-btn",
  filterPrefix: "mosaic-filter-",
  typeSelectorPrefix: "mosaic-type-",
  composerText: "mosaic-composer-text",
  composerSource: "mosaic-composer-source",
  composerSongUrl: "mosaic-composer-song-url",
  composerSongTitle: "mosaic-composer-song-title",
  composerSongArtist: "mosaic-composer-song-artist",
  composerMessageFrom: "mosaic-composer-message-from",
  composerPhoto: "mosaic-composer-photo",
  composerSave: "mosaic-composer-save",
  composerCancel: "mosaic-composer-cancel",
  cardPrefix: "mosaic-card-",
  deletePrefix: "mosaic-delete-",
  emptyState: "mosaic-empty-state",
};

export const ZEN = {
  root: "zen-page",
  exit: "zen-exit-btn",
  prompt: "zen-prompt",
  phase: "zen-phase",
  breathCircle: "zen-breath-circle",
  startDelay: "zen-start-delay",
  delayCountdown: "zen-delay-countdown",
  goSafereach: "zen-go-safereach",
  goJournal: "zen-go-journal",
  goHome: "zen-go-home",
  durationPrefix: "zen-duration-",
  customDuration: "zen-custom-duration",
};

export const PROTECT = {
  root: "protect-page",
  exit: "protect-exit-btn",
  categoryPrefix: "protect-category-",
  input: "protect-input",
  add: "protect-add-btn",
  itemPrefix: "protect-item-",
  deletePrefix: "protect-delete-",
  emptyState: "protect-empty-state",
  examplePrefix: "protect-example-",
};

export const DRAFTS = {
  root: "drafts-page",
  exit: "drafts-exit-btn",
  newBtn: "drafts-new-btn",
  textarea: "drafts-textarea",
  recipient: "drafts-recipient",
  hold: "drafts-hold-btn",
  cancel: "drafts-cancel-btn",
  itemPrefix: "drafts-item-",
  reviseBtn: "drafts-revise-",
  releaseBtn: "drafts-release-",
  sentBtn: "drafts-sent-",
  holdAgainBtn: "drafts-holdagain-",
  deleteBtn: "drafts-delete-",
  emptyState: "drafts-empty-state",
  resurfacedBanner: "drafts-resurfaced-banner",
};

export const WELCOME_BANNER = {
  heldDrafts: "welcome-held-drafts-banner",
  letters: "welcome-letters-banner",
  nudge: "welcome-nudge-banner",
};

export const ONBOARDING = {
  root: "onboarding-overlay",
  begin: "onboarding-begin-btn",
  input: "onboarding-protect-input",
  keep: "onboarding-keep-btn",
  skip: "onboarding-skip-btn",
};

export const JOURNAL_REFLECT = {
  triggerPrefix: "journal-reflect-",
  responsePrefix: "journal-reflection-",
  loadingPrefix: "journal-reflection-loading-",
};

export const ZEN_REFLECT = {
  openBtn: "zen-reflect-open-btn",
  panel: "zen-reflect-panel",
  textarea: "zen-reflect-textarea",
  submit: "zen-reflect-submit",
  response: "zen-reflect-response",
  closeBtn: "zen-reflect-close-btn",
};

export const LETTERS = {
  root: "letters-page",
  exit: "letters-exit-btn",
  newBtn: "letters-new-btn",
  textarea: "letters-textarea",
  presetPrefix: "letters-preset-",
  send: "letters-send-btn",
  cancel: "letters-cancel-btn",
  sealedPrefix: "letters-sealed-",
  arrivedPrefix: "letters-arrived-",
  bodyPrefix: "letters-body-",
  breakPrefix: "letters-break-",
  deletePrefix: "letters-delete-",
  emptyState: "letters-empty-state",
};

export const SETTINGS = {
  root: "settings-page",
  exit: "settings-exit-btn",
  toggle: "settings-nudges-toggle",
  freqPrefix: "settings-freq-",
  libraryItemPrefix: "settings-library-item-",
  libraryInput: "settings-library-input",
  libraryAdd: "settings-library-add-btn",
  preview: "settings-preview-btn",
};
